import EntityOverviewPage from 'Components/Organisms/Entity/EntityOverviewPage/EntityOverviewPage';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';

const CandidateOverviewPage = () => {
    return (
        <PageTemplate>
            <Helmet>
                <title>{ ROUTES.CANDIDATES.title }</title>
            </Helmet>

            <EntityOverviewPage
                entity_name='candidate'
            />
        </PageTemplate>
    )
}

export default CandidateOverviewPage;